import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

@Component({
    selector: 'fuse-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseNavigationComponent implements OnInit {
    
    @Input()
    layout = 'vertical';
    @Input()
    navigation: any;
    userData: any;
    updatedArray: any
    userRolePermission = [];
    userRolePermissionChild = [];
    expandedItem: any = null;
    userRole: any;
    filterid: any
    bufferSidepannel:any;
    activeItem: any = null; // Property to track the active item
    activeChildItem: any = null;

    sidepanelData = [{
        id: 'dashboards',
        title: 'Dashboard',
        translate: 'NAV.DASHBOARDS',
        type: 'item',
        icon: 'account_circle',
        url: '/apps/dashboard'
    },
    // {
    //     id: 'userrolepermission',
    //     title: 'User Role Permission',
    //     translate: 'NAV.UserRole',
    //     type: 'item',
    //     icon: 'people_outline',
    //     url: '/apps/user-role-permission/userroleList',
    //     // iconImage:'../../assets/icons/User Role Permission 16x16.png'
    // },


    {
        id: 'AutoTransfer',
        title: 'Auto Transfer',
        translate: 'Auto Transfer',
        type: 'collapsable',
        // icon: 'assignment',
        iconImage: '../assets/icons/reportW.svg',
        children: [
            {
                id: 'Companybase',
                title: 'Company Base',
                translate: 'NAV.CompanyBases',
                type: 'item',
                icon: 'domain',
                url: '/apps/company-bases/companybasesList',

            },
            {
                id: 'Individualbase',
                title: 'Individual Base',
                translate: 'NAV.Individualbase',
                type: 'item',
                icon: 'person',
                url: '/apps/IndividualBase/IndividualbaseList',
                // iconImage:'../../assets/icons/Individual Base 16x16.png'

            },
            {
                id: 'Transferdetails',
                title: 'Transfer Details',
                translate: 'NAV.Transferdetails',
                type: 'item',
                icon: 'local_atm',
                url: '/apps/TransferDetails/TransferDetialsList',
                // iconImage:'../../assets/icons/Transfer Detail 16x16.png'

            },
            {
                id: 'blocktransfer',
                title: 'Block Transfer',
                translate: 'NAV.blocktransfer',
                type: 'item',
                icon: 'today',
                url: '/apps/block-transfer/BlocktransferLists',


            },
            {
                id: 'report',
                title: 'Report',
                translate: 'Report',
                type: 'collapsable',
                // icon: 'assignment',
                iconImage: '../assets/icons/reportW.svg',


                children: [
                    {
                        id: 'AutomaticTransferDetailReport',
                        title: 'Automatic Transfer Details',
                        type: 'item',
                        icon: 'file_copy',
                        url: '/apps/report/AutomaticTransferDetailReport',
                        iconImage: './assets/icons/transfer-details-white.svg',
                        activeImage: './assets/icons/transfer-details.svg'
                    },
                    {
                        id: 'AutomaticTransferAmountReport',
                        title: 'Automatic Transfer Amount',
                        type: 'item',
                        icon: 'file_copy',
                        url: '/apps/report/AutomaticTransferAmountReport',
                        iconImage: './assets/icons/transfer-amount-white.svg',
                        activeImage: '../assets/icons/transfer-amount.svg'
                        // activeImage:'../../assets/icons/Transfer Amount_active.png'
                    },
                    {
                        id: 'AutomaticTransferStatusReport',
                        title: 'Automatic Transfer Status',
                        type: 'item',
                        icon: 'file_copy',
                        url: '/apps/report/AutomaticTransferStatusReport',
                        iconImage: './assets/icons/transfer-status-white.svg',
                        activeImage: './assets/icons/transfer-status.svg'
                        // activeImage:'../../assets/icons/Transfer Status_active.png'
                    },
                    {
                        id: 'AutomaticTransferGroupbyReport',
                        title: 'Automatic Transfer Group By',
                        type: 'item',
                        icon: 'file_copy',
                        // iconImage: './assets/icons/transfer-amount-white.svg',
                        url: '/apps/report/AutomaticTransferGroupByReport'
                    }
                ]
            },
        ]
    },
    {
        id: 'AutoRepayment',
        title: 'Auto Repayment',
        translate: 'Auto Repayment',
        type: 'collapsable',
        // icon: 'assignment',
        iconImage: '../assets/icons/autopay-white.svg',
        children: [
            {
                id: 'CompanybaseRp',
                title: 'Company Base',
                translate: 'NAV.autopaycompanybase',
                type: 'item',
                url: '/apps/autopay-company-bases/autopaycompanybasesList',
                icon: 'domain',
                activeImage: './assets/icons/autopay-company-base.svg'

            },
            {
                id: 'IndividualbaseRp',
                title: 'Individual Base',
                translate: 'NAV.autopayindividualbase',
                type: 'item',
                url: '/apps/autopay-individual-bases/autopayindividualbasesList',
                icon: 'person',
                activeImage: './assets/icons/autopay-individual-base.svg'
                // iconImage:'../../assets/icons/Individual Base 16x16.png'

            },
            {
                id: 'TransferdetailsRp',
                title: 'Transfer Details',
                translate: 'NAV.autopaytransferdetails',
                type: 'item',
                url: '/apps/autopay-transfer-detail/autopaytransferdetail',
                icon: 'local_atm',
                activeImage: './assets/icons/autopay-transfer-details.svg'
                // iconImage:'../../assets/icons/Transfer Detail 16x16.png'
            },

            // {
            //     id: 'blocktransfers',
            //     title: 'Auto Pay Block Transfers',
            //     translate: 'NAV.autoblocktransfer',
            //     type: 'item',
            //     icon: 'today',
            //     url: '/apps/block-transfers/BlocktransferLists',

            // },


            {
                id: 'reportRp',
                title: 'Report',
                translate: 'NAV.autopayreport',
                type: 'collapsable',
                // icon: 'assignment',
                iconImage: '../assets/icons/autopay-report-white.svg',


                children: [
                    {
                        id: 'AutomaticTransferDetailReport',
                        title: 'Auto Pay Transfer Detail',
                        type: 'item',
                        icon: 'file_copy',
                        url: '/apps/AutopayReport/AutopayTransferDetailReport',
                        iconImage: './assets/icons/autopay-transfer-details-report-white.svg',
                        activeImage: './assets/icons/autopay-transfer-details-report.svg',
                    },
                    // {
                    //     id: 'AutomaticTransferAmountReport',
                    //     title: 'Automatic Transfer Amount',
                    //     type: 'item',
                    //     url: '/apps/AutopayReport/AutopayTransferAmountReport',
                    //     iconImage:'./assets/icons/transfer-amount-white.svg',
                    //     activeImage:'./assets/icons/transfer-amount.svg'
                    // },
                    {
                        id: 'AutomaticTransferStatusReport',
                        title: 'Auto Pay Transfer Status',
                        type: 'item',
                        icon: 'file_copy',
                        url: '/apps/AutopayReport/AutopayTransferStatusReport',
                        iconImage: './assets/icons/autopay-transfer-status-report-white.svg',
                        activeImage: './assets/icons/autopay-transfer-status-report.svg'
                        // activeImage:'../../assets/icons/Transfer Status_active.png'
                    },
                    {
                        id: 'AutomaticTransferGroupbyReport',
                        title: 'Auto Pay Group By',
                        type: 'item',
                        icon: 'file_copy',
                        url: '/apps/AutopayReport/AutopayGroupbyReport',
                        iconImage: './assets/icons/autopay-groupby-report-white.svg',
                        activeImage: './assets/icons/autopay-groupby-report.svg'
                    }
                ]
            },
        ]
    },
    {
        id: 'Changepassword',
        title: 'Change Password',
        translate: 'NAV.changepassword',
        type: 'item',
        icon: 'lock',
        url: '/apps/changepassword/changepassword',
        // iconImage:'../../assets/icons/Change Password 16x16.png'
    },
    {
        id: 'Logout',
        title: 'Logout',
        translate: 'Logout',
        type: 'item',
        icon: 'power_settings_new',
        url: '/apps/logout/logout',

    }]

    

    // Private
    private _unsubscribeAll: Subject<any>;
    parent: any;
    child: any;

    /**
     *
     * @param {ChangeDetectorRef} _changeDetectorRef
     * @param {FuseNavigationService} _fuseNavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    // Track currently expanded items
    expandedMainItem: any = null;
    expandedChildItem: any = null;
    expandedGrandchildItem: any = null;

    isCollapsable(item: any): boolean {
        return item.children && item.children.length > 0;
    }

    isCollapsable1(child: any): boolean {
        return child.children && child.children.length > 0;
    }

    isCollapsable2(grandchild: any): boolean {
        return grandchild.children && grandchild.children.length > 0;
    }

    isActive(item: any): boolean {
        // return item === this.activeItem;
        return this.activeItem && this.activeItem.url === item.url;
    }

    onItemClick(item: any): void {
        localStorage.removeItem('parents');
        localStorage.removeItem('childs');
        this.collapseAllItems();
        if (!this.isCollapsable(item)) {
            this.activeItem = item; // Set the clicked item as active
            
            localStorage.setItem('ActiveItem', JSON.stringify(this.activeItem))
            this.setActiveDashboard()
            this.sidepanelData = this.bufferSidepannel;
        } else {
            this.toggleMainItem(item);

        }
    }

    // }
    onItemClicks(item: any): void {

        if (!this.isCollapsable(item)) {
            this.activeItem = item; // Set the clicked item as active
            localStorage.setItem('ActiveItem', JSON.stringify(this.activeItem))
            
            this.setActiveDashboard()
            
        } else {
            // If item is a main item, toggle it
            this.toggleMainItem(item);
            this.collapseAllItems();
        }
    }
    onItemClickss(item: any): void {
        if (!this.isCollapsable(item)) {
            this.activeItem = item; // Set the clicked item as active
            
            localStorage.setItem('ActiveItem', JSON.stringify(this.activeItem))
            this.setActiveDashboard()
        } else {
            // If item is a main item, toggle it
            this.toggleMainItem(item);
        }

    }

    toggleMainItem(item: any): void {
        


        if (this.expandedMainItem && this.expandedMainItem !== item) {
            this.collapseItem(this.expandedMainItem);
        }
        item['expanded'] = !item['expanded'];

        this.expandedMainItem = item['expanded'] ? item : null;
        if (!item['expanded']) {
            this.collapseChildren(item);
        }
        localStorage.setItem('parents', JSON.stringify(this.expandedMainItem))
        this.sidepanelData = this.bufferSidepannel;
    }

    getItemClass(item: any): string {
        return item['expanded'] ? 'expanded-item' : 'collapsed-item';
    }

    getChildrenClass(item: any): string {
        return item['expanded'] ? 'expanded-children' : 'collapsed-children';
    }
    onChildItemClick(child: any): void {
        // Set the clicked item as active
        this.activeChildItem = child;
        // Optionally, you might want to perform other actions here
    }
    toggleChildItem(mainItem: any, child: any): void {
        

        if (this.expandedChildItem && this.expandedChildItem !== child) {
            this.collapseItem(this.expandedChildItem);
        }

        if (this.expandedGrandchildItem && this.expandedGrandchildItem.parent === this.expandedChildItem) {
            this.expandedGrandchildItem['expanded'] = false;
        }
        child['expanded'] = !child['expanded'];
        this.expandedChildItem = child['expanded'] ? child : null;
        localStorage.setItem('childs', JSON.stringify(this.expandedChildItem))
    }

    toggleGrandchildItem(child: any, grandchild: any): void {

        if (this.expandedGrandchildItem && this.expandedGrandchildItem !== grandchild) {
            this.expandedGrandchildItem['expanded'] = false;
        }

        grandchild['expanded'] = !grandchild['expanded'];
        this.expandedGrandchildItem = grandchild['expanded'] ? grandchild : null;
    }

    private collapseItem(item: any): void {
        item['expanded'] = false;
        if (item.children) {
            item.children.forEach(child => {
                this.collapseItem(child);
            });
        }
    }

    private collapseChildren(mainItem: any): void {
        if (mainItem.children) {
            mainItem.children.forEach(child => {
                this.collapseItem(child);
            });
        }
    }

    private collapseGrandchildren(child: any): void {
        if (child.children) {
            child.children.forEach(grandchild => {
                this.collapseItem(grandchild);
            });
        }
    }

    private collapseAllItems(): void {
        if (this.expandedMainItem) {
            this.collapseItem(this.expandedMainItem);
            this.expandedMainItem = null;
        }
        if (this.expandedChildItem) {
            this.collapseItem(this.expandedChildItem);
            this.expandedChildItem = null;
        }
        if (this.expandedGrandchildItem) {
            this.expandedGrandchildItem['expanded'] = false;
            this.expandedGrandchildItem = null;
        }
    }


    ngOnInit(): void {
        
        this.userRolePermission = [];
        this.userData = JSON.parse(localStorage.getItem('userData'));
        this.userRole = this.userData.UserRoles[0].Value;
        const paymentTypeNames = this.userData.PaymentTypeMasterDetails.map(item => item.PaymentTypeName);
        var updatedStrings = paymentTypeNames.map(function (originalString) {
            return originalString.replace("Auto", "Auto ");
        });


        this.filterid = updatedStrings;
        if (this.userData.PaymentTypeMasterDetails) {

            this.userData.PaymentTypeMasterDetails.forEach((item) => {
                if (item.PaymentTypeValue == 0) {
                    this.userRolePermission.push("AutoTransfer");

                }
                else if (item.PaymentTypeValue == 1) {
                    this.userRolePermission.push("AutoRepayment");
                }


            })
        }


        this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();
        if (this.userRole === 0 || this.userRole === 1) {
            this.sidepanelData.splice(1, 0, { // Insert at index 1, adjust index if necessary
                id: 'userrolepermission',
                title: 'User Role Permission',
                translate: 'NAV.UserRole',
                type: 'item',
                icon: 'people_outline',
                url: '/apps/user-role-permission/userroleList',
            });
        }
        
        const a = this.userData.UserPermissionDetails;
        const filter = a.map(item => ({
            PaymentTypeId: item.PaymentTypeId,
            title: item.PaymentTypeId === "cf60d5b6-be73-11ee-ac7d-04421a875b4d" ? "Auto Repayment" : "Auto Transfer",
            ModuleName: item.UserPermission ? item.UserPermission.ModuleName : 'Unknown'
        }));


        // Extract titles and module names from secondArray
        const titleToModulesMap = filter.reduce((map, item) => {
            if (!map[item.title]) {
                map[item.title] = new Set();
            }
            map[item.title].add(item.ModuleName);
            return map;
        }, {});

       const hasAutoTransfer = 'Auto Transfer' in titleToModulesMap;
        const hasAutoRepayment = 'Auto Repayment' in titleToModulesMap;

        const filteredMainArray = this.sidepanelData
            .filter(item => {
                if (item.title === 'Auto Transfer' && !hasAutoTransfer) return false;
                if (item.title === 'Auto Repayment' && !hasAutoRepayment) return false;
                return true;
            })
            .reduce((result, mainItem) => {
                const matchingModules = titleToModulesMap[mainItem.title] || new Set();

                if (matchingModules.size > 0) {
                    const filteredChildren = mainItem.children.filter(child =>
                        matchingModules.has(child.title)
                    );

                    if (filteredChildren.length > 0) {
                        result.push({ ...mainItem, children: filteredChildren });
                    }
                } else {
                    result.push(mainItem);
                }

                return result;
            }, []);

        
        const updatedMainArray = filteredMainArray.map(item => {
            if (item.title === 'Auto Repayment') {
                return {
                    ...item,
                    children: item.children.map(child => ({
                        ...child,
                        title: `Auto Pay ${child.title}`,
                        children: child.children ? child.children.map(grandChild => ({
                            ...grandChild,
                            title: `${grandChild.title}` // Update grandchildren
                        })) : [] // Ensure grandchildren are updated if they exist
                    }))
                };
            }
            return item;
        });

        
        this.sidepanelData = updatedMainArray;

        this._fuseNavigationService.onNavigationChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {


                const userType = this.userData.UserRoles[0].UserType
                
                this.navigation = this._fuseNavigationService.getCurrentNavigation();
                this._changeDetectorRef.markForCheck();
            });

        merge(
            this._fuseNavigationService.onNavigationItemAdded,
            this._fuseNavigationService.onNavigationItemUpdated,
            this._fuseNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {


                this._changeDetectorRef.markForCheck();
            });

            this.bufferSidepannel = this.sidepanelData

        // Set dashboard as active after login
        this.activeItem = JSON.parse(localStorage.getItem('ActiveItem'))
        this.setActiveDashboard();

        this.parent = JSON.parse(localStorage.getItem('parents'));
        this.child = JSON.parse(localStorage.getItem('childs'));
        if (this.parent !== null) {
            
            const updatedArray = this.sidepanelData.map(item => 
                item.id === this.parent.id ? this.parent : item
            );
            
            this.sidepanelData = updatedArray
        }
        
        if (this.child !== null) {
            
            
            this.sidepanelData = this.sidepanelData.map(item => {
                if (item.id === this.parent.id) {
                    const updatedItem = { ...this.parent };
                if (updatedItem.children && Array.isArray(updatedItem.children)) {
                        updatedItem.children = updatedItem.children.map(child => 
                            child.id === this.child.id ? this.child : child
                        );
                    }
        
                    return updatedItem;
                }
                return item;    
            });
        
            
        }
          }


    setActiveDashboard() {
        
        if (this.activeItem == null) {
            this.activeItem = this.sidepanelData.find(item => item.title === 'Dashboard');
            
        }
        else {
            this.activeItem = JSON.parse(localStorage.getItem('ActiveItem'))
            
        }   
    }


    
 }

